import { BYTES_PER_MEGABYTE } from '../constants/fileSize.constants';

export const exceedsFileSizeLimit = (file, maxSizeMB) => file.size > maxSizeMB * BYTES_PER_MEGABYTE;
